module.exports = __webpack_public_path__ + "img/accuffr_ct.c0f46bf4.png";